// extracted by mini-css-extract-plugin
export default {"blog":"styles_blog__ikCKU","blog__link":"styles_blog__link__WvHIy","item":"styles_item__+wrkz","item__in":"styles_item__in__Pc1xo"};